export const setToken = (state, token) => state.token = token

export const setAuth = (state, auth) => state.auth = auth


// WEBPACK FOOTER //
// ./src/store/main/mutations.js